import { useEffect } from "react";

import { useRouter } from "next/router";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { getFromLocalStorage } from "@/common/helpers/localStorage";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";
import { ContainerLoader } from "@/components/Loaders/ContainerLoader";
import { useIsUnsupportedBrowserForDashboard } from "@/features/UnsupportedBrowser/useIsUnsupportedBrowser";

const UNSUPPORTED_BROWSER_PATHNAME = "/unsupported-browser";

export const RedirectOnUnsupportedDashboardBrowser = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const { logAmplitudeEvent } = useAmplitude();

  const bypassed = getFromLocalStorage?.("bypassDashboardUnsupportedBrowser");
  const isUnsupportedBrowser = useIsUnsupportedBrowserForDashboard();

  const shouldRedirect =
    isUnsupportedBrowser && bypassed !== "true" && router.isReady && router.pathname !== UNSUPPORTED_BROWSER_PATHNAME;

  useEffect(() => {
    if (shouldRedirect) {
      router.replace(
        `${UNSUPPORTED_BROWSER_PATHNAME}?source=dashboard&returnUrl=${encodeURIComponent(window.location.href)}`,
        undefined,
        {
          shallow: true,
        }
      );
    }
  }, [router, shouldRedirect]);

  useEffect(() => {
    // Send an event to Amplitude if a user would have been redirected to the unsupported browser page
    if (isUnsupportedBrowser) {
      logAmplitudeEvent(AmplitudeEvents.UnsupportedBrowserRedirection, {
        source: "dashboard",
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (shouldRedirect) {
    return <ContainerLoader fullPage />;
  }

  return <>{children}</>;
};
